var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 0C0.716344 0 0 0.716344 0 1.6V4.8C0 5.68366 0.716344 6.4 1.6 6.4H4.8C5.68366 6.4 6.4 5.68366 6.4 4.8V1.6C6.4 0.716344 5.68366 0 4.8 0H1.6ZM1.6 9.6C0.716344 9.6 0 10.3163 0 11.2V14.4C0 15.2837 0.716344 16 1.6 16H4.8C5.68366 16 6.4 15.2837 6.4 14.4V11.2C6.4 10.3163 5.68366 9.6 4.8 9.6H1.6ZM9.6 11.2C9.6 10.3163 10.3163 9.6 11.2 9.6H14.4C15.2837 9.6 16 10.3163 16 11.2V14.4C16 15.2837 15.2837 16 14.4 16H11.2C10.3163 16 9.6 15.2837 9.6 14.4V11.2ZM11.2 0C10.3163 0 9.6 0.716344 9.6 1.6V4.8C9.6 5.68366 10.3163 6.4 11.2 6.4H14.4C15.2837 6.4 16 5.68366 16 4.8V1.6C16 0.716344 15.2837 0 14.4 0H11.2Z",
    fill: "#FE8700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.a508e04f25bced28f0830eabe757fd60.svg";
export { ForwardRef as ReactComponent };